// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimAssignRequestDto
 */
export interface IClaimAssignRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimAssignRequestDto
     */
    contact_id?: number;
    /**
     * 
     * @type {Set<number>}
     * @memberof IClaimAssignRequestDto
     */
    claim_ids?: Set<number>;
}

/**
 * Check if a given object implements the IClaimAssignRequestDto interface.
 */
export function instanceOfIClaimAssignRequestDto(value: object): value is IClaimAssignRequestDto {
    return true;
}

export function IClaimAssignRequestDtoFromJSON(json: any): IClaimAssignRequestDto {
    return IClaimAssignRequestDtoFromJSONTyped(json, false);
}

export function IClaimAssignRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimAssignRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'claim_ids': json['claim_ids'] == null ? undefined : new Set(json['claim_ids']),
    };
}

export function IClaimAssignRequestDtoToJSON(json: any): IClaimAssignRequestDto {
    return IClaimAssignRequestDtoToJSONTyped(json, false);
}

export function IClaimAssignRequestDtoToJSONTyped(value?: IClaimAssignRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact_id': value['contact_id'],
        'claim_ids': value['claim_ids'] == null ? undefined : Array.from(value['claim_ids'] as Set<any>),
    };
}

